// @flow

export const PROVIDER_EXCLUDE_BOOKING = {
  kayak: ["SKYPICKER"],
}

export const PROVIDER_KIWI_NAME = "Kiwi.com"
export const PROVIDER_KIWI_CODE = "KIWI"

export const PROVIDER = {
  kiwi: {
    name: PROVIDER_KIWI_NAME,
    logo: null,
  },
  kayak: {
    name: "KAYAK",
    logo: "/images/icons/providers/kayak.svg",
  },
}

export const PROVIDER_PRICE_MARGIN = {
  limit: 166,
  flat: 5,
  percent: 3,
}
